import { lazy } from 'react';
import { Navigate } from 'react-router';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACCEPT_CAREGIVERS_FILL_MY_INFO_PATH,
  ACTION_BACK_PATH,
  ADD_CARE_GIVERS_PATH,
  ADD_CARE_GIVERS_SUCCESS_PATH,
  ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH,
  CANCEL_CARE_GIVERS_PATH,
  CARE_GIVERS_ADD_FAMILY_FRIEND_PATH,
  CARE_GIVERS_FILL_MY_INFO_PATH,
  MY_CARE_GIVERS_PATH,
  UPDATE_CARE_GIVERS_DETAILS_PATH,
  UPDATE_CARE_GIVERS_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const AddCaregivers = lazy(() => import('@features/Caregivers/FamilyFriends/Caregivers/pages/AddCaregivers'));
const MyCareGivers = lazy(() => import('@features/Caregivers/FamilyFriends/Caregivers/pages/MyCaregivers'));
const CaregiverRequestSuccess = lazy(
  () => import('@features/Caregivers/FamilyFriends/Caregivers/components/CaregiverRequestSuccess')
);
const ApprovalCaregiverRequest = lazy(
  () => import('@features/Caregivers/FamilyFriends/Caregivers/components/Approval')
);
const CaregiversRecords = lazy(() => import('@features/Caregivers/FamilyFriends/Caregivers/pages/CaregiversRecords'));
const NewFamilyFriend = lazy(
  () => import('@features/Caregivers/FamilyFriends/CareRecipients/components/NewFamilyFriend')
);

const CancelCaregiverPage = lazy(
  () => import('@features/Caregivers/FamilyFriends/Caregivers/pages/CancelCaregiverPage')
);

export const CAREGIVERS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MyCareGivers />,
    displayTitle: () => 'My Caregivers',
    pageType: PageType.PRIVATE,
    path: MY_CARE_GIVERS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CaregiversRecords />,
    displayTitle: () => 'Update Caregiver’s Details',
    pageType: PageType.PRIVATE,
    path: UPDATE_CARE_GIVERS_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <AddCaregivers />,
    displayTitle: () => 'Add Caregivers',
    pageType: PageType.PRIVATE,
    path: ADD_CARE_GIVERS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ApprovalCaregiverRequest />,
    displayTitle: () => 'Add Caregivers',
    pageType: PageType.PRIVATE,
    path: ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CaregiverRequestSuccess />,
    displayTitle: () => 'Add Caregivers',
    pageType: PageType.PRIVATE,
    path: ADD_CARE_GIVERS_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CaregiverRequestSuccess />,
    displayTitle: () => `Update Caregiver's Details`,
    pageType: PageType.PRIVATE,
    path: UPDATE_CARE_GIVERS_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <NewFamilyFriend />,
    displayTitle: () => 'Add Family & Friends',
    pageType: PageType.PRIVATE,
    path: CARE_GIVERS_ADD_FAMILY_FRIEND_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <Navigate replace to={ADD_CARE_GIVERS_PATH} />,
    displayTitle: () => 'Add Caregivers',
    pageType: PageType.PRIVATE,
    path: CARE_GIVERS_FILL_MY_INFO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <Navigate replace to={ADD_CAREGIVERS_RECEIVED_APPROVAL_PATH} />,
    displayTitle: () => 'Add Caregivers',
    pageType: PageType.PRIVATE,
    path: ACCEPT_CAREGIVERS_FILL_MY_INFO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CancelCaregiverPage />,
    displayTitle: () => "Caregiver's Details",
    pageType: PageType.PRIVATE,
    path: CANCEL_CARE_GIVERS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.caregiver,
  },
];
